import React from 'react'
import { Table as AntTable } from 'antd';
import CMS from '../../components/cms/CMS'
import { Switch } from 'antd'
import { useTranslation } from 'react-i18next';
import { Button, Input } from 'reactstrap';
import { BiSearch } from 'react-icons/bi';

const RolesPage = () => {
    const { t } = useTranslation();
    const data = [
        {
            "id": 1,
            "name": "Ömer Poyraz",
            "read": true,
            "write": false,
            "delete": true,
            "liberyus": true,
            "fabrika": false,
        },
        {
            "id": 2,
            "name": "Fırat Çelik",
            "read": true,
            "write": true,
            "delete": false,
            "liberyus": true,
            "fabrika": false,
        },
        {
            "id": 3,
            "name": "Büşra Koçarslan",
            "read": false,
            "write": true,
            "delete": true,
            "liberyus": true,
            "fabrika": false,
        },
        {
            "id": 4,
            "name": "Rabia Çulhacık",
            "read": true,
            "write": false,
            "delete": true,
            "liberyus": true,
            "fabrika": false,
        },
        {
            "id": 5,
            "name": "Burak Tekir",
            "read": true,
            "write": true,
            "delete": false,
            "liberyus": true,
            "fabrika": false,
        },
    ]

    const columns = [
        {
            title: t("name"),
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (a) => {
                return (
                    <div className='d-flex align-items-center justify-content-start'>
                        <div>{a.name}</div>
                    </div>
                )
            },
        },
        {
            title: t("read"),
            key: 'read',
            render: (a) => {
                return (
                    <Switch checked={a.read} className="custom-switch w40px" />
                )
            }
        },
        {
            title: t("write"),
            key: 'write',
            render: (a) => {
                return (
                    <Switch checked={a.write} className="custom-switch w40px" />
                )
            }
        },
        {
            title: t("delete"),
            key: 'delete',
            render: (a) => {
                return (
                    <Switch checked={a.delete} className="custom-switch w40px" />
                )
            }
        },
        {
            title: 'Liberyus',
            key: 'read',
            render: (a) => {
                return (
                    <Switch checked={a.liberyus} className="custom-switch w40px" />
                )
            }
        },
        {
            title: 'Fabrika',
            key: 'fabrika',
            render: (a) => {
                return (
                    <Switch checked={a.fabrika} className="custom-switch w40px" />
                )
            }
        }
    ];

    return (
        <CMS>
            <div className='d-flex justify-content-end mt-3'>
                <div>
                    <Input type='text' className='h40px' placeholder={t("search_user")} />
                </div>
                <div className='ml-2'>
                    <Button className='rounded pb border-0 f14 h40px'><BiSearch className='mr-1' size={18} />{t("search")}</Button>
                </div>
            </div>
            <div className="border rounded overflow-hidden mt-3">
                <AntTable
                    columns={columns}
                    dataSource={data}
                    scroll={{ x: true }}
                />
            </div>
        </CMS>
    )
}

export default RolesPage
